import {Title} from './title';
export class Eventlog{
    id: number;
    content_id: string;
    note: string;
    event_owner_id: number;
    event_type = 'Internal_Comment';
    entry_date: Date;
    titleObject: Title;

}


// WEBPACK FOOTER //
// ./src/app/tms/model/eventlog.ts